import { useState, useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import './App.css';

// Import router components
import PCRouter from './components/pc/PCRouter';
import MobileRouter from './components/mobile/MobileRouter';

function App() {
  const [isDarkMode, setIsDarkMode] = useState(true);

  // Check for mobile device
  const [isMobile, setIsMobile] = useState(false);

  // Function to check if device is mobile
  const checkIfMobile = () => {
    return /Mobi|Android/i.test(navigator.userAgent) || window.innerWidth < 768;
  };

  // Set initial value and add resize listener
  useEffect(() => {
    setIsMobile(checkIfMobile());

    const handleResize = () => {
      setIsMobile(checkIfMobile());
    };

    window.addEventListener('resize', handleResize);

    // Clean up listener on component unmount
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Check for dark mode preference and apply theme class to body
  useEffect(() => {
    if (localStorage.getItem('AviSiteTheme')) {
      const savedTheme = localStorage.getItem('AviSiteTheme');
      setIsDarkMode(savedTheme === 'dark');

      // Apply the theme class to body
      if (savedTheme === 'dark') {
        document.body.classList.add('alternate-theme');
      } else {
        document.body.classList.remove('alternate-theme');
      }
    } else {
      // For mobile, default to light mode; for desktop, check system preference
      if (isMobile) {
        setIsDarkMode(false);
        document.body.classList.remove('alternate-theme');
      } else {
        // Check system preference for desktop
        const isDarkPreferred = window.matchMedia('(prefers-color-scheme: dark)').matches;
        setIsDarkMode(isDarkPreferred);

        // Apply theme based on system preference
        if (isDarkPreferred) {
          document.body.classList.add('alternate-theme');
        } else {
          document.body.classList.remove('alternate-theme');
        }
      }
    }
  }, [isMobile]);

  // Toggle theme function
  const toggleTheme = () => {
    const newMode = !isDarkMode;
    setIsDarkMode(newMode);
    localStorage.setItem('AviSiteTheme', newMode ? 'dark' : 'light');

    // Apply or remove the alternate-theme class from body
    if (newMode) {
      document.body.classList.add('alternate-theme');
    } else {
      document.body.classList.remove('alternate-theme');
    }
  };

  return (
    <div className="App transition-effect">
      <BrowserRouter>
        {isMobile ? (
          // Mobile layout with React Router for page navigation
          <MobileRouter isDarkMode={isDarkMode} toggleTheme={toggleTheme} />
        ) : (
          // Desktop layout with React Router for page navigation
          <PCRouter isDarkMode={isDarkMode} toggleTheme={toggleTheme} />
        )}
      </BrowserRouter>
    </div>
  );
}

export default App;